<template>
	<div class="c-board-select">
		<div class="c-board-select__header" v-if="currentBoards.length > 10">
			<InputText v-model="query" placeholder="Search for a board"></InputText>
		</div>
		<div class="c-board-select__inner">
			<draggable v-bind="dragOptions" tag="div" v-model="currentBoards" handle=".c-board-select__handle" @end="onEnd" @start="drag = true">
				<transition-group type="transition" :name="!drag ? 'flip-list' : null">
					<router-link class="c-board-select__item" @click.native="onClick" :to="`/boards/${board.slug}`" v-for="board in computedBoards" :key="board.slug">
						<svg v-if="!query" class="c-board-select__handle" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M3 6H21M3 12H21M3 18H21" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
						</svg>
						<span v-else class="blank-icon"></span>

						<div :class="['c-board-select__counter', { active: board._count > 0 }]">
							{{ board._count || 0 }}
						</div>
						<span
							><svg v-if="board.hidden" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path
									d="M10.607 4.09497C10.0598 4.16981 9.67686 4.67407 9.75171 5.22126C9.82655 5.76845 10.3308 6.15137 10.878 6.07652L10.607 4.09497ZM21.4978 11.0953L22.3571 10.5838L21.4978 11.0953ZM19.5181 14.02C19.1738 14.4519 19.2449 15.081 19.6767 15.4253C20.1086 15.7695 20.7378 15.6985 21.082 15.2666L19.5181 14.02ZM21.498 12.9043L22.3573 13.4157L21.498 12.9043ZM3.7071 2.29289C3.31657 1.90237 2.68341 1.90237 2.29288 2.29289C1.90236 2.68342 1.90236 3.31658 2.29288 3.70711L3.7071 2.29289ZM9.87867 9.87868L10.5858 9.17157L9.87867 9.87868ZM20.2929 21.7071C20.6834 22.0976 21.3166 22.0976 21.7071 21.7071C22.0976 21.3166 22.0976 20.6834 21.7071 20.2929L20.2929 21.7071ZM2.50204 11.0956L1.64273 10.5841H1.64273L2.50204 11.0956ZM7.18936 7.48108C7.65205 7.17953 7.78267 6.55998 7.48111 6.09729C7.17956 5.6346 6.56001 5.50398 6.09732 5.80554L7.18936 7.48108ZM2.5031 12.9062L3.36234 12.3947L2.5031 12.9062ZM17.9027 18.1944C18.3653 17.8928 18.496 17.2733 18.1944 16.8106C17.8929 16.3479 17.2733 16.2173 16.8106 16.5188L17.9027 18.1944ZM10.878 6.07652C14.3525 5.6013 18.0999 7.34166 20.6385 11.6068L22.3571 10.5838C19.4847 5.75792 15.0159 3.49193 10.607 4.09497L10.878 6.07652ZM21.082 15.2666C21.5347 14.6987 21.9611 14.0815 22.3573 13.4157L20.6387 12.3928C20.2871 12.9836 19.9121 13.5257 19.5181 14.02L21.082 15.2666ZM20.6385 11.6068C20.7829 11.8493 20.7828 12.1507 20.6387 12.3928L22.3573 13.4157C22.8769 12.5429 22.8765 11.4564 22.3571 10.5838L20.6385 11.6068ZM12 14C10.8954 14 9.99999 13.1046 9.99999 12H7.99999C7.99999 14.2091 9.79085 16 12 16V14ZM2.29288 3.70711L9.17156 10.5858L10.5858 9.17157L3.7071 2.29289L2.29288 3.70711ZM9.99999 12C9.99999 11.4474 10.2228 10.9488 10.5858 10.5858L9.17156 9.17157C8.4488 9.89434 7.99999 10.8957 7.99999 12H9.99999ZM9.17156 10.5858L13.4142 14.8284L14.8284 13.4142L10.5858 9.17157L9.17156 10.5858ZM13.4142 14.8284L20.2929 21.7071L21.7071 20.2929L14.8284 13.4142L13.4142 14.8284ZM13.4142 13.4142C13.0512 13.7772 12.5526 14 12 14V16C13.1043 16 14.1057 15.5512 14.8284 14.8284L13.4142 13.4142ZM2.29288 3.70711L20.2929 21.7071L21.7071 20.2929L3.7071 2.29289L2.29288 3.70711ZM3.36135 11.607C4.45475 9.77 5.77434 8.40332 7.18936 7.48108L6.09732 5.80554C4.39937 6.91217 2.87506 8.51367 1.64273 10.5841L3.36135 11.607ZM1.64386 13.4178C3.59164 16.6894 6.27059 18.7893 9.19312 19.6107C12.121 20.4335 15.212 19.948 17.9027 18.1944L16.8106 16.5188C14.5833 17.9705 12.085 18.3459 9.73422 17.6852C7.37815 17.0231 5.08928 15.2953 3.36234 12.3947L1.64386 13.4178ZM1.64273 10.5841C1.12268 11.4579 1.1249 12.5461 1.64386 13.4178L3.36234 12.3947C3.21748 12.1514 3.21772 11.8483 3.36135 11.607L1.64273 10.5841Z"
									fill="currentColor"
								/>
							</svg>
							{{ board.name }}</span
						>
						<svg @click.prevent="updateBoard(board)" class="muted" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M13.5 6L15.5858 3.91422C16.3668 3.13317 17.6332 3.13317 18.4142 3.91422L20.0858 5.58579C20.8668 6.36684 20.8668 7.63317 20.0858 8.41422L18 10.5M13.5 6L3.29289 16.2071C3.10536 16.3946 3 16.649 3 16.9142V21H7.08579C7.351 21 7.60536 20.8946 7.79289 20.7071L18 10.5M13.5 6L18 10.5"
								stroke="currentColor"
								stroke-width="2"
								stroke-linecap="round"
								stroke-linejoin="round"
							/>
						</svg>
					</router-link>
				</transition-group>
			</draggable>
			<article class="c-board-select__empty-state" v-if="currentBoards.length === 0">
				<p>No boards created.</p>
				<span> Organize your Ads by creating boards. </span>
			</article>
		</div>
		<!-- <div class="c-board-select__inner">
			<div class="c-board-select__item">Project one</div>
		</div> -->
		<!-- <div class="c-board-select__add">
			<a class="c-board-select__item" @click.prevent="addBoard" href="#">
				<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path
						fill-rule="evenodd"
						clip-rule="evenodd"
						d="M12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0ZM12.75 7C12.75 6.58579 12.4142 6.25 12 6.25C11.5858 6.25 11.25 6.58579 11.25 7V11.25H7C6.58579 11.25 6.25 11.5858 6.25 12C6.25 12.4142 6.58579 12.75 7 12.75H11.25V17C11.25 17.4142 11.5858 17.75 12 17.75C12.4142 17.75 12.75 17.4142 12.75 17V12.75H17C17.4142 12.75 17.75 12.4142 17.75 12C17.75 11.5858 17.4142 11.25 17 11.25H12.75V7Z"
						fill="currentColor"
					/>
				</svg>
				<span> Add Board </span>
			</a>
			<a class="c-board-select__item" @click.prevent="uploadAd" href="#">
				<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path
						fill-rule="evenodd"
						clip-rule="evenodd"
						d="M12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0ZM12.75 7C12.75 6.58579 12.4142 6.25 12 6.25C11.5858 6.25 11.25 6.58579 11.25 7V11.25H7C6.58579 11.25 6.25 11.5858 6.25 12C6.25 12.4142 6.58579 12.75 7 12.75H11.25V17C11.25 17.4142 11.5858 17.75 12 17.75C12.4142 17.75 12.75 17.4142 12.75 17V12.75H17C17.4142 12.75 17.75 12.4142 17.75 12C17.75 11.5858 17.4142 11.25 17 11.25H12.75V7Z"
						fill="currentColor"
					/>
				</svg>
				<span> Upload Ad </span>
			</a>
		</div> -->
	</div>
</template>

<script>
import draggable from 'vuedraggable';

import api from '@swipekit/lib/api';

import InputText from '@swipekit/components/form/input-text';

import Fuse from 'fuse.js';

export default {
	components: {
		draggable,
		InputText,
	},

	data: function () {
		return {
			query: '',
			currentBoards: [],

			drag: false,
		};
	},

	watch: {
		boards: {
			immediate: true,
			handler: function () {
				this.currentBoards = this.boards;
			},
		},
	},

	computed: {
		dragOptions() {
			return {
				animation: 200,
				group: 'description',
				disabled: false,
				ghostClass: 'ghost',
			};
		},
		workspace: function () {
			return this.$store.getters['workspaces/all'];
		},
		user: function () {
			return this.$store.getters['users/user'];
		},
		isAdmin: function () {
			return this.$store.getters['users/isAdmin'];
		},
		computedBoards: function () {
			let boards = this.currentBoards;

			boards = JSON.parse(JSON.stringify(boards));

			// Only do this for non-admin users
			if (!this.isAdmin) {
				boards = boards.filter((board) => {
					if (board.hidden && board.userId !== this.user.id) {
						return false;
					}

					return true;
				});
			}

			if (this.query) {
				let options = {
					keys: ['name'],
				};
				let fuse = new Fuse(boards, options);
				let items = fuse.search(this.query);
				items = items.map((i) => {
					return i.item;
				});
				return items;
			}

			return boards;
		},
		init: function () {
			return this.$store.getters['app/init'];
		},
		boards: function () {
			let boards = this.$store.getters['boards/filtered'];

			return boards;
		},
	},

	methods: {
		onClick: function () {
			this.$store.dispatch('app/toggleSidebar');
		},
		onEnd: function () {
			this.drag = false;
			this.setOrder();
		},
		setOrder: function () {
			let newArr = [];
			this.currentBoards.map((b, i) => {
				newArr.push({
					id: b.id,
					order: i,
				});
			});

			const obj = {
				boards: newArr,
			};

			api.boards.setOrder(obj);
		},
		updateBoard: function (board) {
			this.$store.dispatch('boards/setEdit', board.id);
		},
	},
};
</script>

<style lang="scss">
.c-board-select {
	height: 100%;

	.flip-list-move {
		transition: transform 250ms;
	}

	.no-move {
		transition: transform 0s;
	}

	.sortable-ghost {
		opacity: 0.5;
		//background: #c8ebfb;
	}

	&__header {
		padding: var(--margin);

		.form-group {
			padding-bottom: 0;
		}
	}

	&__inner {
		height: calc(100% - 82px);
		overflow-y: auto;
	}

	&__counter {
		width: 24px;
		height: 24px;
		min-width: 24px;
		margin-right: var(--margin);
		background-color: var(--color-font);
		color: #fff;
		border-radius: 99px;
		text-align: center;
		line-height: 1.8;
		font-size: var(--font-size-xs);
	}

	&__item {
		position: relative;
		display: flex;
		align-items: center;
		padding: var(--margin);
		font-size: var(--font-size-sm);
		text-decoration: none !important;
		border-radius: 10px;
		color: var(--color-font);
		transition: all 120ms ease-out;

		// &:after {
		//   content: "";
		//   position: absolute;
		//   bottom: 0;
		//   left: 0;
		//   height: 4px;
		//   width: 100%;
		//   border-radius: 99px;
		//   background-color: var(--color-primary);
		//   opacity: 0;
		// }

		// &.sortable-chosen {
		//   &:after {
		//     opacity: 1;
		//   }
		// }

		span {
			display: flex;
			align-items: center;
			word-break: break-word;

			svg {
				width: 20px;
				height: 20px;
				margin-right: var(--margin-sm);
			}
		}

		svg {
			min-width: 24px;
			opacity: 0.55;

			&:hover {
				opacity: 1;
			}
		}

		svg:first-of-type {
			margin-right: var(--margin);
			cursor: grab;
		}

		svg:last-of-type {
			margin-left: auto;
		}

		&:hover,
		&:active,
		&.router-link-active {
			background-color: var(--color-primary);
			color: var(--color-bg-1);
		}

		// &.sortable-chosen {
		//   &:after {
		//     opacity: 1;
		//   }
		// }
	}

	&__add {
		padding-top: var(--margin);
		margin-top: var(--margin);
		border-top: hsl(var(--p), 8%, 42%) solid 1px;

		.c-board-select__item {
			svg:last-of-type {
				margin-left: initial;
			}
		}
	}

	&__empty-state {
		text-align: center;
		padding: var(--spacer);

		> p {
			opacity: 0.75;
			margin-bottom: var(--margin);
		}
	}
}
</style>
